<template>
    <div class="focus-pair-box">
        <el-input v-model="params.pairName" style="margin-bottom: 10px;width: 400px" placeholder="输入关键字搜索">
            <el-button slot="append" icon="el-icon-search" @click="searchPair"></el-button>
        </el-input>
        <div class="preview-opration">
            <el-button style="margin-left: 30px" icon="el-icon-plus" type="danger" @click="openCreatePairDialog">新增交易对
            </el-button>
        </div>
        <br>
        <span>当前操作板块：{{currName}}</span>
        <div class="pair-list">
            <el-table class="pair-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="pairList" :row-key="() => Math.random()">
                <el-table-column prop="orderNum" label="序号"></el-table-column>
                <el-table-column prop="pairName" label="交易对名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="exchangeCoin" label="交易币种" show-overflow-tooltip></el-table-column>
                <el-table-column prop="anchoredCoin" label="锚定币种" show-overflow-tooltip></el-table-column>
                <el-table-column prop="header" label="是否龙头" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.header" active-color="#13ce66" disabled=""
                                   inactive-color="#ff4949"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="修改时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.updateTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="300">
                    <template slot-scope="scope">
                        <el-button type="danger" @click="updatePairDialog(scope.row)">修改</el-button>
                        <el-button type="danger" @click="deletePair(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="params.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="params.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>

        <div style="text-align: center">
            <el-button type="primary" @click="goBank()">返回</el-button>
        </div>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%" @close="clearData"
                   :close-on-click-modal="false">
            <el-form label-width="150px" :model="pairData" :rules="pairRules" ref="pairForm">
                <el-form-item label="排序号：" prop="orderNum">
                    <el-input-number v-model="pairData.orderNum" :min="1" :max="10000000"
                                     label="排序号"></el-input-number>
                </el-form-item>
                <el-form-item label="是否龙头：" prop="header">
                    <el-switch v-model="pairData.header" active-color="#13ce66"
                               inactive-color="#ff4949"></el-switch>
                </el-form-item>
                <el-form-item label="交易对名称：" prop="pairName">
                    <el-autocomplete class="inline-input" style="width: 500px"
                                     v-model="pairData.pairName"
                                     :fetch-suggestions="querySearch"
                                     placeholder="交易对名称"
                                     @select="handleSelect"
                                     @keyup.native.enter="handleSearch">
                        <i class="el-icon-close el-input__icon" slot="suffix"
                           @click="cleanSearchCoin" style="cursor:pointer;">
                        </i>
                    </el-autocomplete>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="addPairDialog">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import '../store';
    import api from '../api';

    export default {
        name: 'PlateManage',
        data() {
            return {
                pairList: [],
                total: 0,
                params: {plateId: "", pairName: "", page: 1, size: 10},
                dialogVisible: false,
                dialogTitle: "新增",
                currOpration: "1", //1-新增，2-修改
                loading: false,
                pairData: {
                    id: "",
                    plateId: "",
                    pairName: "",
                    header: false,
                    orderNum: ""
                },
                pairRules: {
                    "plateId": [{required: true, message: "板块id不能为空"}],
                    "pairName": [{required: true, message: "交易对名称不能为空"}],
                    "header": [{required: true, message: "是否龙头不能为空"}],
                    "orderNum": [{required: true, message: "序号不能为空"}],
                },
                currName: "",
                currPlateId: "",
                coinTypes: [],
            }
        },
        methods: {
            getAllSupportingPairs() {
                api.getAllSupportingPairs().then(({data}) => {
                    this.coinTypes = [];
                    for(let i=0;i<data.length;i++){
                        this.coinTypes.push(data[i].exchangeCoin+"_"+data[i].anchoredCoin)
                    }
                });
            },
            searchPair() {
                this.params.page = 1;
                this.getPlatePairList(this.params);
            },
            getPlatePairList(query) {
                query.plateId = this.currPlateId;
                api.getPlatePairList(query).then(({data}) => {
                    this.total = data.totalCount;
                    this.pairList = data.list;
                });
            },
            addPairDialog() {
                this.$refs["pairForm"].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        if (this.currOpration == "1") {
                            api.addPlatePair(this.pairData).then(() => {
                                this.$message.success("创建成功！");
                                this.getPlatePairList(this.params);
                                this.loading = false;
                                this.dialogVisible = false;
                            });
                        } else if (this.currOpration == "2") {
                            api.updatePlatePair(this.pairData).then(() => {
                                this.$message.success("修改成功！");
                                this.getPlatePairList(this.params);
                                this.loading = false;
                                this.dialogVisible = false;
                            });
                        }
                    }
                });
            },
            deletePair(id) {
                this.$confirm('确认此删除吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.deletePlatePair({id: id}).then(({data}) => {
                        this.$message.success('操作成功！');
                        this.getPlatePairList(this.params);
                    });
                }).catch(() => {
                });
            },
            openCreatePairDialog() {
                this.pairData.plateId = this.currPlateId;
                this.currOpration = "1";
                this.dialogTitle = "新增";
                this.dialogVisible = true;
            },
            updatePairDialog(row) {
                this.pairData = {
                    id: row.id,
                    plateId: this.currPlateId,
                    pairName: row.pairName,
                    header: row.header,
                    orderNum: row.orderNum
                }
                this.currOpration = "2";
                this.dialogTitle = "修改";
                this.dialogVisible = true;
            },
            handleSizeChange(val) {
                this.params.size = val;
                this.getPlatePairList(this.params);
            },
            handleCurrentChange(val) {
                this.params.page = val;
                this.getPlatePairList(this.params);
            },
            goBank() {
                this.$router.go(-1);
            },
            clearData() {
                this.dialogTitle = "新增";
                this.currOpration = "1"; //1-新增，2-修改
                this.loading = false;
                this.pairData = {
                    id: "",
                    plateId: "",
                    pairName: "",
                    header: false,
                    orderNum: ""
                }
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.coinTypes;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.coinTypes;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanSearchCoin() {
                this.pairData.pairName = '';
            },
            handleSearch() {

            },
            handleSelect() {
            },
        },
        created() {
            this.currPlateId = this.$route.query.id;
            this.currName = this.$route.query.name;
            this.getPlatePairList(this.params);
            this.getAllSupportingPairs();
        }
    };
</script>

<style lang="less" scoped>
    .focus-pair-box {
        .preview-opration {
            float: right;
        }

        .pair-list {
            border: 1px solid #f2ece2;
            clear: both;
            width: 100%;
            .pair-table {
                margin-top: 30px;
            }
        }
    }
</style>

